import {AI_PROMO_STATUSES} from '../../configs/aiMatch';

// Пока состав не зафиксирован — до фазы банов
const LEAVE_ALLOWED_STATUSES = new Set([AI_PROMO_STATUSES.WAITING, AI_PROMO_STATUSES.COUNTDOWN]);

/**
 * Можно ли игроку самому выйти из ИИ-лобби.
 *
 * Рейтинговые лобби без создателя обычно покинуть нельзя — партию ведет
 * сервер. ИИ-лобби тоже ведет сервер (создатель — сам ИИ), но собирается
 * оно долго, до получаса: держать человека силой нельзя. Поэтому выйти
 * можно, пока сервер ждет игроков или отсчитывает время до старта, — и
 * нельзя с началом фазы банов: состав уже поделен, как в обычном
 * рейтинговом матче. Сервер сам снимет таймер, если ушли все.
 *
 * Статус неизвестен (старый сервер, мусор в дескрипторе) — судим только по
 * меткам фаз: без них лобби еще собирается, и запирать игрока в нем без
 * кнопки выхода хуже, чем отпустить.
 *
 * Зритель выходит всегда — это проверяет вызывающий код
 * (checkIfAiLobbySpectator).
 *
 * @param {Object} lobby - private.lobby
 * @returns {boolean}
 */
export const checkIfAiLobbyLeaveAllowed = (lobby) => {
  if (!lobby?.isAiMatch) return false;
  if (lobby.factionBanDeadlineAt || lobby.rankMatchStartAt) return false;
  if ((lobby.players || []).some((player) => player?.bannedFactionId)) return false;
  const status = lobby.aiPromo?.status;
  return status ? LEAVE_ALLOWED_STATUSES.has(status) : true;
};
